import { createSlice } from '@reduxjs/toolkit';
import { NAME_REDUCER } from './constants';
import { ICouponReceiveResData, ICouponReceiveDiscountSetting, ICouponReferralSetting, ICustomerCouponTarget, IApiGetCouponReceiveV2Body } from '../types';
import actions from './actions';
type IState = {
  couponReceive: ICouponReceiveResData | null;
  couponReceiveDiscountSetting: ICouponReceiveDiscountSetting | null;
  birthdayDiscount: ICouponReceiveDiscountSetting | null;
  couponReferralSetting: ICouponReferralSetting | null;
  customerCouponTarget: ICustomerCouponTarget | null;
  payloadResendOtp?: IApiGetCouponReceiveV2Body | null;
  refIdReceiveCoupon?: string | null;
};
const initialState: IState = {
  couponReceive: null,
  couponReceiveDiscountSetting: null,
  birthdayDiscount: null,
  couponReferralSetting: null,
  customerCouponTarget: null,
  payloadResendOtp: null,
  refIdReceiveCoupon: null,
};

export const Slice = createSlice({
  name: NAME_REDUCER,
  initialState,
  reducers: {
    setCouponReceive: (state, { payload }: { payload: ICouponReceiveResData }) => {
      state.couponReceive = payload;
    },
    setCustomerCouponTarget: (state, { payload }: { payload: ICustomerCouponTarget }) => {
      state.customerCouponTarget = payload;
    },
    setPayloadResendOtp: (state, { payload }: { payload: IApiGetCouponReceiveV2Body | null }) => {
      state.payloadResendOtp = payload;
    },
    setRefIdReceiveCoupon: (state, { payload }: { payload: string | null }) => {
      state.refIdReceiveCoupon = payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(actions.getBirthdayDiscount.fetch, (state) => {
        state.birthdayDiscount = null;
      })
      .addCase(actions.getBirthdayDiscount.success, (state, { payload }) => {
        state.birthdayDiscount = payload;
      })
      .addCase(actions.getCouponReceiveDiscountSetting.fetch, (state) => {
        state.couponReceiveDiscountSetting = null;
      })
      .addCase(actions.getCouponReceiveDiscountSetting.success, (state, { payload }) => {
        state.couponReceiveDiscountSetting = payload;
      })
      .addCase(actions.getReferralDiscountExitsCustomer.fetch, (state) => {
        state.couponReferralSetting = null;
      })
      .addCase(actions.getReferralDiscountExitsCustomer.success, (state, { payload }) => {
        state.couponReferralSetting = payload;
      });
  },
});

const couponServiceReducer = Slice.reducer;
export const couponActions = {
  ...Slice.actions,
  ...actions,
};
export default couponServiceReducer;
